// 文章5数据信息
export default {
  id: 'dayunshan_105',
  content: `# 换一款主食，控血压还能稳血糖
  ![大云山国家森林公园1](https://cdn.keihong.tech/img/20250518213154790.jpg)
![大云山国家森林公园2](https://cdn.keihong.tech/img/20250518213222797.jpg)
![大云山国家森林公园3](https://cdn.keihong.tech/img/20250518213216431.jpg)
![大云山国家森林公园3](https://cdn.keihong.tech/img/20250518213241684.jpg)
`
}
